var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"fixed":"right","header-align":"center","align":"center","width":_vm.columnWidth,"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.expanded)?[_vm._t("default",null,{"row":scope.row})]:_vm._e()]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }